export enum UserRole {
  admin = "ADMIN",
  editor = "EDITOR",
  god = "GOD",
  sale = "SALE",
  csm = "CSM",
}
